import React, { Component } from 'react';
import CSSModules from 'react-css-modules'
import config from '../../config'
import container from '../../helpers/container'
import {
  // Link,
  // LinkIcon,
  ContainerDivs,
  BenchmarkGrid,
  BenchmarkGridTable,
  GetStartedInput
} from '../../components'
import Styles from './IndexFunds.css'

@CSSModules(Styles)
export default class IndexFunds extends Component {
  constructor(props) {
    super(props)
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    const title = 'Index funds'
    const description = 'Get your money out of fossil fuels. Fossil Free Funds tracks thousands of mutual funds commonly found in retirement plans.'
    const url = config.domain + config.routes.indexfunds
    //    
    return <div styleName='page'>
      {container.helmet(title, description, url)}

      <BenchmarkGrid/>

      { /* <ContainerDivs>
        <section styleName='index-funds-section'>
          <h2 styleName='index-funds-page-title'>
            Passive index investing and climate change
          </h2>

          <p>
            As active investment exits these unsustainable industries,
            passive investors are
            becoming the “holders of last resort” ensuring
            that losses will be borne overwhelmingly by
            average investors, savers, pensioners, and
            retirees.
          </p>

          <p>
            Several more paragraphs, a few chart images.
          </p>

        </section>
      </ContainerDivs> */ }

      <br/>
      <br/>
      <br/>

      <GetStartedInput />
    </div>
  }
}
